import { render } from "./PickSupplier.vue?vue&type=template&id=561bbd12&scoped=true"
import script from "./PickSupplier.vue?vue&type=script&lang=js"
export * from "./PickSupplier.vue?vue&type=script&lang=js"

import "./PickSupplier.vue?vue&type=style&index=0&id=561bbd12&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-561bbd12"]])

export default __exports__